const text = `[[topSection]]Wir halten Ihre Online-Privatsphäre für wichtig. Deshalb möchten wir Sie über Folgendes informieren:

Wir speichern einige Informationen auf Ihrem Gerät, damit diese Website funktioniert. Ihr Gerät kann auch von "[[thirdPartiesUrl]]" zur ähnlichen Informationsspeicherung genutzt werden.

Personenbezogene Daten wie Ihre IP-Adresse und eindeutige Benutzer-IDs können von uns und von "[[thirdPartiesUrl]]" für die folgenden Zwecke verwendet werden, für die "[[thirdPartiesUrl]]" Ihre Zustimmung einholen können:
[[purposes]]

Zwecke, für die "[[thirdPartiesUrl]]" ein berechtigtes Interesse ohne Widerspruchsrecht geltend machen:
[[legitimateInterest]]

Und Funktionen, für die "[[thirdPartiesUrl]]" ausdrücklich Ihre Zustimmung verlangen:
[[features]]

Wir stellen dieses Interface zur Verfügung, um Ihnen die Kontrolle über Ihre Datenschutzeinstellungen zu ermöglichen. Sie können Ihre Datenschutzeinstellungen jederzeit ändern, während Sie unsere Website besuchen. Um dieses Dialogfeld zu öffnen, navigieren Sie zur Schaltfläche Datenschutz auf Ihrem Bildschirm.

Neben der Bitte um Ihre Zustimmung können "[[thirdPartiesUrl]]" ein "[[legitimateInterestUrl]]" als Rechtsgrundlage für die Verarbeitung personenbezogener Daten geltend machen. In den meisten Fällen haben Sie das Recht, dem zu widersprechen. Ein Signal zur Weiterleitung Ihres Einspruchs an einen "[[thirdPartiesUrl]]" wird von diesem Datenschutzmanager verwaltet.

Wir und [[totalVendors]] andere [[partnersScreen]]-Mitglieder können nach vollständiger Zustimmung Informationen auf Ihrem Gerät für personalisierte Werbung und Inhalte speichern und/oder darauf zugreifen.

Das Vorenthalten der Zustimmung kann zu mehr geschalteten Anzeigen führen und zu Anzeigen, die nicht Ihren Interessen entsprechen.
Jede Einwilligung, jeder Einspruch und jede ausdrückliche Zustimmung, den/die Sie geben, ist auf diese Website beschränkt.

[[bottomSection]]
`;
export default text;